module.exports = __webpack_public_path__ + "static/media/DSCF0266.796f6a13.jpg";